import React, { FunctionComponent, MouseEvent } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { round } from 'lodash';
import { Box } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { TimeSheet } from '../../../../store/modules/timeSheet/type';

type DaysOfWeekProps = {
    date: string;
    dayOfWeek: string;
    index: number;
    selectedDate: string;
    timeSheet: TimeSheet;
    handleSelectedDate: Function;
};

const useStyles = makeStyles({
    root: {
        cursor: 'pointer',
        height: '58px',
        width: '12.5%',
        marginTop: 10,
        backgroundColor: '#EEEEEE',
        borderRadius: '0px',
        color: '#484848',
        marginRight: 5,
        '&:hover': {
            backgroundColor: '#BDBDBD !important',
            color: 'white',
        },
        '& > .MuiCardContent-root': {
            padding: 8,
        },
    },

    title: {
        fontSize: 18,
        fontWeight: 'bold',
    },
    pos: {
        marginBottom: 12,
    },
    dateTimeContainer: {
        display: 'flex',
        width: '100%',
    },
    dateStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        width: '50%',
    },
    hoursStyle: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '50%',
    },
    selected: {
        backgroundColor: '#757575',
        color: 'white',
    },
});

const DaysOfWeek: FunctionComponent<DaysOfWeekProps> = (props) => {
    const classes = useStyles();
    const { dayOfWeek, date, index, handleSelectedDate, selectedDate, timeSheet } = props;

    const rootStyle = classNames({
        [classes.root]: true,
        [classes.selected]: date === selectedDate,
    });

    const handleSelectedCardDate = (event: MouseEvent, index: number) => {
        event.stopPropagation();
        handleSelectedDate(index);
    };

    const totalHoursForDay = timeSheet.timeCards
        .find((timeCard) => moment(timeCard.date).format('MMM D') === date)
        ?.timeEntries?.reduce((accum, timeEntry) => accum + (timeEntry.unitHours ? timeEntry.unitHours : 0), 0);

    return (
        <Card className={rootStyle} onClick={(event: MouseEvent) => handleSelectedCardDate(event, index)}>
            <CardContent>
                <Typography className={classes.title} component="h1">
                    {dayOfWeek}
                </Typography>
                <Box className={classes.dateTimeContainer}>
                    <Typography component="h3" className={classes.dateStyle}>
                        {date}
                    </Typography>
                    <Typography component="h3" className={classes.hoursStyle}>
                        {!!totalHoursForDay ? round(totalHoursForDay, 2) : 0} Hrs
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default DaysOfWeek;
